export const IconHome = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.519} height={15.694}>
    <g data-name="Gruppe 45">
      <g data-name="Gruppe 44">
        <path
          data-name="Pfad 60"
          d="m17.333 6.168-8.3-6.08a.455.455 0 0 0-.538 0l-8.3 6.08a.455.455 0 0 0 .538.735L8.768 1.02l8.027 5.882a.455.455 0 0 0 .538-.735Z"
        />
      </g>
    </g>
    <g data-name="Gruppe 47">
      <g data-name="Gruppe 46">
        <path
          data-name="Pfad 61"
          d="M15.201 6.991a.46.46 0 0 0-.46.46v7.323H11.06v-4a2.3 2.3 0 1 0-4.6 0v4H2.778V7.448a.46.46 0 0 0-.92 0v7.783a.46.46 0 0 0 .46.46h4.6a.46.46 0 0 0 .458-.424.348.348 0 0 0 0-.036v-4.458a1.38 1.38 0 0 1 2.761 0v4.458a.338.338 0 0 0 0 .035.46.46 0 0 0 .458.425h4.6a.46.46 0 0 0 .46-.46V7.448a.46.46 0 0 0-.454-.457Z"
        />
      </g>
    </g>
  </svg>
);

export const IconCamera = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25.567} height={19.735}>
    <g data-name="Gruppe 53">
      <g data-name="Gruppe 52">
        <path
          data-name="Pfad 64"
          d="M12.784 4.697a6.567 6.567 0 1 0 6.567 6.567 6.574 6.574 0 0 0-6.567-6.567Zm0 12.088a5.521 5.521 0 1 1 5.521-5.521 5.528 5.528 0 0 1-5.521 5.521Z"
        />
      </g>
    </g>
    <g data-name="Gruppe 55">
      <g data-name="Gruppe 54">
        <path
          data-name="Pfad 65"
          d="M12.783 7.167a4.1 4.1 0 1 0 4.1 4.1 4.1 4.1 0 0 0-4.1-4.1Zm0 7.2a3.107 3.107 0 1 1 3.107-3.107 3.11 3.11 0 0 1-3.107 3.111Z"
        />
      </g>
    </g>
    <g data-name="Gruppe 57">
      <g data-name="Gruppe 56">
        <path
          data-name="Pfad 66"
          d="M23.916 2.793h-6.731L16.5.921A1.41 1.41 0 0 0 15.181 0h-4.792A1.41 1.41 0 0 0 9.07.921l-.688 1.873H6.1V2.06A1.074 1.074 0 0 0 5.027.987H3.438A1.074 1.074 0 0 0 2.365 2.06v.734h-.714A1.653 1.653 0 0 0 0 4.444v13.64a1.653 1.653 0 0 0 1.651 1.651h22.265a1.653 1.653 0 0 0 1.651-1.651V4.444a1.653 1.653 0 0 0-1.651-1.651ZM10.1 1.304a.305.305 0 0 1 .286-.2h4.789a.305.305 0 0 1 .286.2l.548 1.493H9.555Zm-6.693.759a.028.028 0 0 1 .028-.028h1.587a.028.028 0 0 1 .028.028v.734H3.411Zm-2.31 4.9h1.63v8.612H1.1Zm23.369 11.121a.551.551 0 0 1-.55.55H1.651a.551.551 0 0 1-.55-.55v-1.413h2.18a.55.55 0 0 0 .55-.55V6.404a.55.55 0 0 0-.55-.55H1.1v-1.41a.551.551 0 0 1 .55-.55h22.266a.551.551 0 0 1 .55.55v1.413h-2.18a.55.55 0 0 0-.55.55v9.713a.55.55 0 0 0 .55.55h2.18v1.414Zm0-2.514h-1.63V6.958h1.63Z"
        />
      </g>
    </g>
    <g data-name="Gruppe 59">
      <g data-name="Gruppe 58">
        <path
          data-name="Pfad 67"
          d="M12.784 9.24a2.027 2.027 0 0 0-2.025 2.025.5.5 0 0 0 .991 0 1.035 1.035 0 0 1 1.034-1.034.5.5 0 0 0 0-.991Z"
        />
      </g>
    </g>
  </svg>
);

export const IconBriefCase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20.134} height={20.019}>
    <g>
      <path
        data-name="Pfad 68"
        d="M1.836 10.61a.3.3 0 0 0 .295-.295v-.272a.295.295 0 0 0-.59 0v.272a.3.3 0 0 0 .295.295Z"
      />
      <path data-name="Pfad 69" d="M1.541 11.554a.295.295 0 0 0 .59 0v-.272a.295.295 0 0 0-.59 0Z" />
      <path data-name="Pfad 70" d="M1.541 12.793a.295.295 0 0 0 .59 0v-.267a.295.295 0 0 0-.59 0Z" />
      <path data-name="Pfad 71" d="M1.541 14.033a.295.295 0 0 0 .59 0v-.272a.295.295 0 0 0-.59 0Z" />
      <path data-name="Pfad 72" d="M1.541 15.275a.295.295 0 1 0 .59 0v-.271a.295.295 0 1 0-.59 0Z" />
      <path data-name="Pfad 73" d="M1.541 16.511a.3.3 0 0 0 .295.295h.272a.452.452 0 1 0-.566-.566v.271Z" />
      <path
        data-name="Pfad 74"
        d="M18.298 10.61a.3.3 0 0 0 .295-.295v-.272a.295.295 0 0 0-.59 0v.272a.3.3 0 0 0 .295.295Z"
      />
      <path data-name="Pfad 75" d="M18.003 11.554a.295.295 0 1 0 .59 0v-.272a.295.295 0 0 0-.59 0Z" />
      <path data-name="Pfad 76" d="M18.003 12.793a.295.295 0 0 0 .59 0v-.267a.295.295 0 0 0-.59 0Z" />
      <path data-name="Pfad 77" d="M18.003 14.033a.295.295 0 1 0 .59 0v-.272a.295.295 0 0 0-.59 0Z" />
      <path data-name="Pfad 78" d="M18.003 15.275a.295.295 0 1 0 .59 0v-.271a.295.295 0 1 0-.59 0Z" />
      <path data-name="Pfad 79" d="M8.303 16.807a.295.295 0 1 0 0-.59h-.272a.295.295 0 1 0 0 .59Z" />
      <path data-name="Pfad 80" d="M7.064 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 1 0 0 .59Z" />
      <path data-name="Pfad 81" d="M5.829 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 82" d="M4.585 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 1 0 0 .59Z" />
      <path data-name="Pfad 83" d="M3.346 16.807a.295.295 0 1 0 0-.59h-.272a.295.295 0 1 0 0 .59Z" />
      <path
        data-name="Pfad 84"
        d="M17.731 16.511a.3.3 0 0 0 .295.295h.271a.3.3 0 0 0 .295-.295v-.272a.6.6 0 0 0-.861.272Z"
      />
      <path data-name="Pfad 85" d="M17.058 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 86" d="M15.819 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 87" d="M14.579 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 88" d="M13.34 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 89" d="M12.101 16.807a.295.295 0 0 0 0-.59h-.272a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 90" d="M10.822 16.807a.295.295 0 0 0 0-.59h-.271a.295.295 0 0 0 0 .59Z" />
      <path data-name="Pfad 91" d="M9.582 16.807a.295.295 0 0 0 0-.59H9.31a.295.295 0 0 0 0 .59Z" />
      <path
        data-name="Pfad 92"
        d="M20.134 4.184a1.244 1.244 0 0 0-1.243-1.243h-.82v-.319a1.29 1.29 0 0 0-1.288-1.288h-1.377a.7.7 0 0 0-.615.363 4.118 4.118 0 0 1-1.8-.622A5.744 5.744 0 0 0 10.068 0a5.744 5.744 0 0 0-2.924 1.075 4.117 4.117 0 0 1-1.8.622.7.7 0 0 0-.615-.363H3.351a1.29 1.29 0 0 0-1.288 1.288v.319h-.82A1.244 1.244 0 0 0 0 4.184v3.048a2.176 2.176 0 0 0 .289 1.086v5.283a.295.295 0 1 0 .59 0V8.986a2.179 2.179 0 0 0 1.312.437h1.348v2.248a1.75 1.75 0 0 0 .582 1.318 1.166 1.166 0 0 0 .777.323 1.166 1.166 0 0 0 .777-.323 1.75 1.75 0 0 0 .582-1.318V9.423h1.616a.295.295 0 0 0 0-.59H6.257v-.568h.1a.533.533 0 0 0 .532-.532v-.862a.533.533 0 0 0-.532-.532H3.44a.533.533 0 0 0-.532.532v.862a.533.533 0 0 0 .532.532h.1v.568H2.191a1.6 1.6 0 0 1-1.6-1.6V4.184a.654.654 0 0 1 .653-.653h17.647a.654.654 0 0 1 .653.653v3.048a1.6 1.6 0 0 1-1.6 1.6h-1.349v-.567h.1a.533.533 0 0 0 .532-.532v-.862a.533.533 0 0 0-.532-.532h-2.917a.533.533 0 0 0-.532.532v.862a.533.533 0 0 0 .532.532h.1v.568H9.3a.295.295 0 0 0 0 .59h4.576v.15a.295.295 0 0 0 .59 0V8.265h1.539v3.406a1.16 1.16 0 0 1-.382.875.516.516 0 0 1-.775 0 1.16 1.16 0 0 1-.382-.875V11a.295.295 0 1 0-.59 0v.671a1.75 1.75 0 0 0 .582 1.318 1.1 1.1 0 0 0 1.555 0 1.75 1.75 0 0 0 .582-1.318V9.423h1.348a2.179 2.179 0 0 0 1.312-.437v8.29H.879v-2.248a.295.295 0 0 0-.59 0v3.748a1.244 1.244 0 0 0 1.243 1.243H18.6a1.244 1.244 0 0 0 1.243-1.243V8.32a2.176 2.176 0 0 0 .291-1.088V4.184ZM3.5 6.929h2.8v.746H3.5Zm2.168 1.336v3.406a1.16 1.16 0 0 1-.382.876.6.6 0 0 1-.388.175.6.6 0 0 1-.387-.175 1.16 1.16 0 0 1-.382-.875V8.265h1.539Zm9.738-6.341h1.377a.7.7 0 0 1 .7.7v.319h-2.191v-.9a.114.114 0 0 1 .114-.119Zm-7.945-.351A5.2 5.2 0 0 1 10.067.59a5.2 5.2 0 0 1 2.606.983 4.71 4.71 0 0 0 2.03.708v.638a5.321 5.321 0 0 1-2.37-.81 4.906 4.906 0 0 0-2.265-.884 4.907 4.907 0 0 0-2.268.884 5.321 5.321 0 0 1-2.37.81v-.638a4.709 4.709 0 0 0 2.03-.708ZM2.653 2.622a.7.7 0 0 1 .7-.7h1.375a.113.113 0 0 1 .113.113v.9H2.653Zm4.863.319a5.95 5.95 0 0 0 .6-.335 4.307 4.307 0 0 1 1.949-.792 4.307 4.307 0 0 1 1.949.792 5.955 5.955 0 0 0 .6.335Zm6.321 3.987h2.8v.746h-2.8Zm4.766 12.5H1.532a.654.654 0 0 1-.653-.653v-.911h18.375v.911a.654.654 0 0 1-.654.654Z"
      />
      <path
        data-name="Pfad 93"
        d="M4.898 11.497a.3.3 0 0 0 .295-.295v-.447a.295.295 0 0 0-.59 0v.447a.3.3 0 0 0 .295.295Z"
      />
      <path data-name="Pfad 94" d="M15.531 11.202v-.447a.295.295 0 0 0-.59 0v.447a.295.295 0 1 0 .59 0Z" />
    </g>
  </svg>
);

export const IconQuiz = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20.554} height={23.386}>
    <g data-name="Capa 1">
      <path
        data-name="Pfad 200"
        d="M14.387 6.897a2.058 2.058 0 0 0-2.055 2.055.685.685 0 1 0 1.37 0 .685.685 0 1 1 .916.645 1.386 1.386 0 0 0-.916 1.3v.109a.685.685 0 1 0 1.37 0v-.109a.012.012 0 0 1 .008-.011 2.055 2.055 0 0 0-.693-3.99Z"
      />
      <ellipse data-name="Ellipse 3" cx={0.849} cy={0.566} rx={0.849} ry={0.566} transform="translate(13.582 12.45)" />
      <path
        data-name="Pfad 201"
        d="M14.388 4.157a6.142 6.142 0 0 0-2.055.353V2.055A2.058 2.058 0 0 0 10.277 0H2.055A2.058 2.058 0 0 0 0 2.055v19.276a2.058 2.058 0 0 0 2.055 2.055h8.222a2.058 2.058 0 0 0 2.055-2.055v-5.137q.289.043.575.113a6.166 6.166 0 1 0 1.481-12.15Zm-4.111 17.859H2.055a.685.685 0 0 1-.685-.685V2.055a.685.685 0 0 1 .685-.685h8.222a.685.685 0 0 1 .685.685V5.2A6.154 6.154 0 0 0 8.4 11.8a5.833 5.833 0 0 1-.441 4.023v.005a.685.685 0 0 0 .923.916 5.83 5.83 0 0 1 2.077-.591v5.174a.685.685 0 0 1-.685.685Zm4.111-6.9a4.754 4.754 0 0 1-1.149-.141 7.217 7.217 0 0 0-3.51 0 7.2 7.2 0 0 0 0-3.51 4.8 4.8 0 1 1 4.656 3.647Z"
      />
      <path
        data-name="Pfad 202"
        d="M8.222 3.471a.685.685 0 0 0-.685-.685H4.796a.685.685 0 0 0 0 1.37h2.741a.685.685 0 0 0 .685-.685Z"
      />
      <circle data-name="Ellipse 4" cx={0.566} cy={0.566} r={0.566} transform="translate(5.659 19.241)" />
      <path
        data-name="Pfad 203"
        d="M4.179 5.618a1.707 1.707 0 0 0-1.705 1.705v3.41h.568V9.598h2.274v1.135h.568V7.324a1.707 1.707 0 0 0-1.705-1.706ZM3.042 9.029V7.324a1.137 1.137 0 0 1 2.274 0v1.705Z"
      />
      <path
        data-name="Pfad 204"
        d="M5.884 13.251a1.422 1.422 0 0 0-1.421-1.421H2.758a.284.284 0 0 0-.284.284v4.548a.284.284 0 0 0 .284.284h1.705a14.019 14.019 0 0 1 1.421-3.695Zm-.568 2.274a.853.853 0 0 1-.853.853H3.042v-1.705h1.421a.853.853 0 0 1 .853.852Zm-.853-1.421H3.042v-1.706h1.421a.853.853 0 1 1 0 1.706Z"
      />
    </g>
  </svg>
);

export const IconBoard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28.666} height={18.623}>
    <g data-name="Ebene 1">
      <g data-name="Gruppe 60">
        <g data-name="Ebene 2">
          <g data-name="Ebene 1">
            <g data-name="Gruppe maskieren 3">
              <path
                data-name="Pfad 619"
                d="M27.211 0H1.456a1.456 1.456 0 0 0 0 2.911h.472v2.13a.419.419 0 0 0 .834 0v-2.13h23.189v13.9a.927.927 0 0 1-.927.937h-21.3a.923.923 0 0 1-.927-.923V7.043a.426.426 0 0 0-.426-.426.415.415 0 0 0-.415.419v9.812a1.775 1.775 0 0 0 1.775 1.775h4.193c1.633-.075 8.343-.057 8.907-.057h8.286a1.775 1.775 0 0 0 1.622-1.775V2.911h.472a1.456 1.456 0 0 0 0-2.911Zm0 2.066H1.456a.611.611 0 1 1 0-1.221h25.755a.611.611 0 0 1 0 1.221Z"
              />
            </g>
          </g>
        </g>
        <g data-name="Rechteck 24" transform="translate(6.195 4.722)" fill="none">
          <rect data-name="Rechteck 42" width={4.924} height={10.554} rx={1.98} />
          <rect
            data-name="board"
            width={4.079}
            height={9.709}
            rx={0.79}
            transform="translate(.422 .422)"
            strokeWidth={0.8}
          />
        </g>
        <g data-name="Rechteck 25" transform="translate(11.822 4.722)" fill="none">
          <rect data-name="Rechteck 44" width={4.924} height={5.627} rx={1.98} />
          <rect
            data-name="board"
            width={4.079}
            height={4.785}
            rx={0.79}
            transform="translate(.422 .422)"
            strokeWidth={0.8}
          />
        </g>
        <g data-name="Rechteck 26" transform="translate(17.448 4.722)" fill="none">
          <rect data-name="Rechteck 46" width={4.924} height={8.442} rx={1.98} />
          <rect
            data-name="board"
            width={4.079}
            height={7.597}
            rx={0.79}
            transform="translate(.422 .422)"
            strokeWidth={0.8}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const IconJourney = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25.564} height={20.201}>
    <path
      data-name="Pfad 635"
      d="M22.817 2.737V1.353a.609.609 0 0 0-.6-.6H20.97a.606.606 0 0 0-.6.6v1.384h2.451ZM7.163 9.467a.374.374 0 0 1 .529-.529l.341.341.947-.948a.375.375 0 0 1 .529.531L8.3 10.073a.375.375 0 0 1-.529 0Zm14.053-4.321a.374.374 0 1 1 .749 0v7.86a.374.374 0 1 1-.749 0Zm-5.9 12.67h2.3V16.21h-2.3Zm2.678.749H5.777a.376.376 0 0 1-.375-.375v-2.355a.374.374 0 0 1 .375-.374h2.68v-2.134a.373.373 0 0 1 .374-.374h3.054a.373.373 0 0 1 .374.374v.669h2.679a.376.376 0 0 1 .375.375v1.094h2.678a.374.374 0 0 1 .375.374v2.355a.376.376 0 0 1-.375.375Zm-5.732-.749h2.3v-3.074h-2.3Zm-3.053 0h2.3v-4.114h-2.3Zm-3.054 0h2.302V16.21H6.151ZM4.572 4.771h15.044V1.353A1.358 1.358 0 0 1 20.97-.004h1.243a1.358 1.358 0 0 1 1.353 1.353v3.418h1.625a.374.374 0 0 1 .374.375v14.686a.373.373 0 0 1-.374.374H14.823a.374.374 0 0 1 0-.749h9.993V5.52h-1.25v2.708a.374.374 0 1 1-.749 0V3.486h-2.451v11.18h2.451V9.925a.374.374 0 1 1 .749 0v5.115a.4.4 0 0 1-.064.212l-1.577 3.105a.381.381 0 0 1-.167.167.373.373 0 0 1-.5-.166l-1.582-3.114a.4.4 0 0 1-.059-.205v-9.52H4.572v2.833a.374.374 0 1 1-.749 0v-7.3a1.986 1.986 0 0 0-1.063-.3A2.01 2.01 0 0 0 .749 2.76v12.792l.059-.062a2.752 2.752 0 0 1 1.952-.808 2.8 2.8 0 0 1 .878.143c.062.021.125.045.185.071v-4.845a.374.374 0 1 1 .749 0v5.487a.374.374 0 0 1-.6.3 1.961 1.961 0 0 0-.572-.3 2.012 2.012 0 1 0-.64 3.919h10.367a.374.374 0 0 1 0 .749H2.76A2.759 2.759 0 0 1 0 17.441V2.76A2.76 2.76 0 0 1 4.4.544a.377.377 0 0 1 .167.313v3.915Zm18.01 10.644H20.6l.992 1.952Zm-5-8.375a.374.374 0 0 1 0 .749h-5.073a.374.374 0 0 1 0-.749Zm-2.112 3.575a.374.374 0 1 1 0 .749h-2.961a.374.374 0 0 1 0-.749Zm2.107-1.788a.374.374 0 0 1 0 .749h-5.068a.374.374 0 0 1 0-.749ZM6.192 6.682h4.29a.374.374 0 0 1 .374.375v4.29a.374.374 0 0 1-.374.375h-4.29a.375.375 0 0 1-.375-.375v-4.29a.375.375 0 0 1 .375-.375Zm3.915.75H6.566v3.541h3.541Z"
    />
  </svg>
);

export const IconBrandCommunity = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20.17} height={20.17}>
    <g data-name="Gruppe 61">
      <g data-name="Gruppe 60">
        <path
          data-name="Pfad 96"
          d="M18.63 17.824a6.485 6.485 0 0 0-3.235-10.451A7.7 7.7 0 0 0 0 7.721a7.607 7.607 0 0 0 1.885 4.993L.177 14.39a.591.591 0 0 0 .414 1.009h6.784a6.535 6.535 0 0 0 6.255 4.767h5.948a.591.591 0 0 0 .413-1.013Zm-16.593-3.6 1.087-1.067a.591.591 0 0 0 0-.84 6.477 6.477 0 0 1-1.942-4.596 6.52 6.52 0 1 1 6.539 6.5Zm11.593 4.764a5.347 5.347 0 0 1-5.03-3.635 7.7 7.7 0 0 0 6.753-6.754 5.347 5.347 0 0 1 3.635 5.034 5.423 5.423 0 0 1-1.6 3.8.591.591 0 0 0 0 .84l.734.717ZM7.721 3.585A4.136 4.136 0 1 0 9.1 11.622a.591.591 0 0 0-.394-1.114 2.955 2.955 0 1 1 1.969-2.786.591.591 0 0 1-1.182 0V6.539a.591.591 0 0 0-.593-.591H7.721A1.773 1.773 0 1 0 8.9 9.041a1.772 1.772 0 0 0 2.955-1.32 4.141 4.141 0 0 0-4.134-4.136Zm.591 4.136a.591.591 0 1 1-.591-.591h.591Z"
        />
      </g>
    </g>
  </svg>
);

export const IconFeed = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={29.08} height={29.08}>
    <g data-name="064-wifi">
      <path
        data-name="Vereinigungsmenge 7"
        d="M7.481 19.565a2.033 2.033 0 0 1 3.471-1.439 2.032 2.032 0 1 1-3.47 1.44ZM9.515 18.5a1.066 1.066 0 1 0 .753.312 1.065 1.065 0 0 0-.752-.312Zm4.604.668A4.638 4.638 0 0 0 9.91 14.96a.958.958 0 0 1-.6-.279.981.981 0 0 1-.283-.682l.005-2.597a.959.959 0 0 1 .303-.702.948.948 0 0 1 .713-.259 9.15 9.15 0 0 1 8.59 8.59.957.957 0 0 1-.26.713.979.979 0 0 1-.704.303h-2.597a.981.981 0 0 1-.684-.285.947.947 0 0 1-.275-.595Zm.963-.085 2.591-.002a8.2 8.2 0 0 0-7.68-7.68l.004 2.597a5.605 5.605 0 0 1 5.086 5.086Zm6.154.039A11.747 11.747 0 0 0 9.959 7.844a.967.967 0 0 1-.93-.964l.004-2.593a.965.965 0 0 1 .999-.963A16.274 16.274 0 0 1 25.758 19.05a.973.973 0 0 1-.277.702.936.936 0 0 1-.693.297H22.2a.972.972 0 0 1-.681-.282.963.963 0 0 1-.283-.646Zm.965-.035 2.59-.002A15.3 15.3 0 0 0 10 4.29v2.59a12.708 12.708 0 0 1 12.207 12.206Z"
      />
    </g>
  </svg>
);

export const IconEarth = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21.68} height={21.68}>
    <path
      data-name="Pfad 782"
      d="M18.505 3.175a10.84 10.84 0 1 0-15.33 15.33 10.84 10.84 0 1 0 15.33-15.33ZM15.92 4.659l.477-1.98a9.913 9.913 0 0 1 3.956 5.5l-.25.048a.98.98 0 0 0-.764.725l-.1.39a.011.011 0 0 1-.009.01.011.011 0 0 1-.013 0l-.578-.434a.982.982 0 0 0-1.04-.084l-.722.378a.978.978 0 0 0 .11 1.781l.034.013a.014.014 0 0 1 .006.022l-.45.517a.014.014 0 0 1-.018 0l-1.212-.782a.977.977 0 0 0-1.495.663l-.09.574a.976.976 0 0 0 .3.872l.632.591a.014.014 0 0 1 0 .018l-1.03 1.561a.978.978 0 0 0-.161.5l-.089 2.235a.014.014 0 0 1 0 .009l-1.372 1.345a.014.014 0 0 1-.017 0l-.889-.521a.014.014 0 0 1-.007-.009s-.432-1.958-.448-2l-.392-1.053a.982.982 0 0 0-.831-.633l-1.8-.156a.014.014 0 0 1-.011-.007l-1.022-1.758a.014.014 0 0 1 0-.009l.257-1.708a.014.014 0 0 1 .005-.009l1.568-1.183a.014.014 0 0 1 .014 0l1.52.634a.979.979 0 0 0 .271.07l2.1.229a.976.976 0 0 0 .675-.177l1.394-1a.981.981 0 0 0 .323-1.193l-.129-.29a.974.974 0 0 0-.839-.577l-3.913-.218h-.012a.028.028 0 0 1 0-.019h.008l1.176-.317a.981.981 0 0 0 .417-.233l1.44-1.365a.014.014 0 0 1 .008 0L15.07 5.4a.979.979 0 0 0 .85-.741Zm-7.33-.8.81-1.518a1.1 1.1 0 0 0 .106-.741L9.4 1.069a9.906 9.906 0 0 1 2.9 0 1.444 1.444 0 0 1-.136.135l-1.146.46a1.1 1.1 0 0 0-.426.305L8.8 4.057a.135.135 0 0 1-.205 0 .19.19 0 0 1-.004-.193Zm-4.211-.483v1.445a1.182 1.182 0 0 1-.541 1L2.8 6.49a2.14 2.14 0 0 0-.606.592l-.941 1.38a9.891 9.891 0 0 1 3.126-5.086Zm.63 14.224-.136 1.1A9.918 9.918 0 0 1 1.5 14.041h.61a.219.219 0 0 1 .185.1l1.24 1.931a1.188 1.188 0 0 0 .2.235l1.206 1.1a.22.22 0 0 1 .068.193Zm5.831 3.119a9.816 9.816 0 0 1-5.071-1.4l.2-1.6a1.185 1.185 0 0 0-.381-1.019s-1.232-1.127-1.243-1.143l-1.24-1.931a1.178 1.178 0 0 0-1-.544h-.89a9.872 9.872 0 0 1-.251-2.242v-.248l2.027-2.967a1.175 1.175 0 0 1 .335-.325l1.037-.673a2.142 2.142 0 0 0 .98-1.8V2.639A9.831 9.831 0 0 1 8.45 1.256l.111.542a.135.135 0 0 1-.013.09L7.74 3.412a2.392 2.392 0 0 0-.116.345A1.1 1.1 0 0 0 8.7 5.068a1.105 1.105 0 0 0 .836-.384L11.321 2.6a.135.135 0 0 1 .052-.038l1.146-.46a1.1 1.1 0 0 0 .424-.3l.432-.5a9.815 9.815 0 0 1 2.164.861c-.011.026-.556 2.278-.556 2.278a.014.014 0 0 1-.012.011l-2.164.223a.983.983 0 0 0-.571.261L10.8 6.285h-.006l-1.176.317a.978.978 0 0 0 .2 1.92l3.916.214a.014.014 0 0 1 .012.008l.129.289a.014.014 0 0 1 0 .017l-1.394 1a.013.013 0 0 1-.01 0l-2.109-.23-1.523-.627a.981.981 0 0 0-.965.122L6.305 10.5a.972.972 0 0 0-.378.635l-.257 1.708a.981.981 0 0 0 .121.636l1.021 1.761a.979.979 0 0 0 .761.483l1.8.156a.014.014 0 0 1 .012.009l.393 1.055.409 1.869a.981.981 0 0 0 .461.635l.89.521a.979.979 0 0 0 1.178-.145l1.372-1.345a.974.974 0 0 0 .293-.659l.089-2.235a.013.013 0 0 1 0-.007l1.03-1.561a.975.975 0 0 0-.148-1.252l-.632-.591a.014.014 0 0 1 0-.012l.094-.571a.014.014 0 0 1 .021-.009l1.212.782a.982.982 0 0 0 1.268-.18l.45-.517a.977.977 0 0 0-.394-1.557l-.034-.013h-.007a.025.025 0 0 1 0-.018h.007l.722-.378a.014.014 0 0 1 .015 0l.578.434a.977.977 0 0 0 1.535-.547l.1-.39a.014.014 0 0 1 .011-.01l.281-.054a9.879 9.879 0 0 1-9.739 11.583Z"
    />
  </svg>
);

export const IconSurvey = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.338} height={21.676}>
    <path
      data-name="Vereinigungsmenge 8"
      d="M3.972 21.676a1.812 1.812 0 0 1-1.8-1.811v-.359h-.363a1.8 1.8 0 0 1-1.8-1.8V1.815a1.812 1.812 0 0 1 1.8-1.811H13.37a1.812 1.812 0 0 1 1.8 1.811v.357h.363a1.807 1.807 0 0 1 1.8 1.8v15.893a1.812 1.812 0 0 1-1.8 1.811ZM2.89 19.865a1.082 1.082 0 0 0 1.082 1.086h11.561a1.082 1.082 0 0 0 1.082-1.086V3.972a1.082 1.082 0 0 0-1.082-1.082h-.363v14.811a1.8 1.8 0 0 1-1.8 1.8H2.895ZM.722 1.81v15.891a1.082 1.082 0 0 0 1.082 1.082h11.561a1.08 1.08 0 0 0 1.08-1.082V1.81a1.082 1.082 0 0 0-1.08-1.088h-.359v2.527a.365.365 0 0 1-.621.256l-.824-.824-.83.824a.356.356 0 0 1-.395.078.351.351 0 0 1-.221-.334V.722H1.804A1.083 1.083 0 0 0 .722 1.811Zm11.094.1.467.471V.721h-1.445v1.66l.465-.471a.365.365 0 0 1 .256-.1.37.37 0 0 1 .257.102Zm-9.289 14.7a.357.357 0 0 1-.359-.359V13.36a.361.361 0 0 1 .359-.359h2.891a.361.361 0 0 1 .359.359v2.891a.357.357 0 0 1-.359.359Zm.363-.723h2.164v-2.164H2.89Zm4.332 0v-.717h3.609v.717Zm2.893-1.441v-.723h.723v.723Zm-2.893 0v-.723h2.17v.723Zm-4.7-2.527a.364.364 0 0 1-.359-.363V8.669a.361.361 0 0 1 .359-.363h2.891a.362.362 0 0 1 .336.238l.49-.5.514.514-.98.975v2.02a.364.364 0 0 1-.359.363Zm.363-.723h2.164v-.937l-.467.467a.355.355 0 0 1-.508 0l-.723-.723.508-.508.467.465.723-.723v-.209H2.885Zm4.332 0v-.723h3.609v.723Zm0-1.445v-.723h2.17v.723Zm-4.7-2.891a.361.361 0 0 1-.359-.359V3.61a.361.361 0 0 1 .359-.359h2.891a.365.365 0 0 1 .336.232l.49-.49.514.508-.98.98v2.02a.361.361 0 0 1-.359.359Zm.363-.725h2.164v-.932l-.467.467a.355.355 0 0 1-.508 0l-.723-.723.508-.508.467.465.723-.723v-.209H2.88Zm4.332 0v-.723h3.609v.723Zm0-1.445v-.723h2.17v.723Z"
    />
  </svg>
);

export const IconChallenges = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="challenge-big-btn-white"
    width="17.249"
    height="20.953"
    viewBox="0 0 17.249 20.953"
  >
    <path
      id="Pfad_95"
      data-name="Pfad 95"
      d="M59.378,4.988l2.841-3.551c-.688-.083-6.146-1.535-11.6-.366V0H49.391V14.868a2.469,2.469,0,0,0-1.849,2.387v.062a3.087,3.087,0,0,0-2.465,3.019v.616h9.86v-.616a3.087,3.087,0,0,0-2.465-3.019v-.062a2.469,2.469,0,0,0-1.849-2.387V9.744a25.951,25.951,0,0,1,11.7.4ZM53.6,19.72H46.415a1.852,1.852,0,0,1,1.743-1.233h3.7A1.852,1.852,0,0,1,53.6,19.72ZM51.24,17.255H48.775a1.233,1.233,0,0,1,2.465,0Zm-.616-8.768V2.332a24,24,0,0,1,9.348-.06l-2.08,2.6,2,3.509a25.935,25.935,0,0,0-9.273.106Z"
      transform="translate(-45.077)"
    />
  </svg>
);

export const IconLogout = ({ secondaryColor }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 14 14">
    <g id="Logout-btn-pink" transform="translate(11.385 12.263) rotate(180)">
      <g id="Gruppe_29" data-name="Gruppe 29">
        <path
          id="Pfad_33"
          data-name="Pfad 33"
          d="M22.583,11.324H19.45a1.544,1.544,0,0,1-1.542-1.542V2.231A1.544,1.544,0,0,1,19.45.688h3.184a.344.344,0,0,0,0-.688H19.45a2.233,2.233,0,0,0-2.231,2.231V9.782a2.233,2.233,0,0,0,2.231,2.231h3.133a.344.344,0,0,0,0-.688Z"
          transform="translate(-17.219)"
          fill={secondaryColor}
          stroke={secondaryColor}
          stroke-width="0.5"
        />
        <path
          id="Pfad_34"
          data-name="Pfad 34"
          d="M128.919,138.614l-2.187-2.187a.344.344,0,0,0-.487.487l1.6,1.6h-6.983a.344.344,0,1,0,0,.688h6.983l-1.6,1.6a.345.345,0,0,0,.242.589.336.336,0,0,0,.242-.1l2.187-2.187A.344.344,0,0,0,128.919,138.614Z"
          transform="translate(-117.885 -132.85)"
          fill={secondaryColor}
          stroke={secondaryColor}
          stroke-width="0.5"
        />
      </g>
    </g>
  </svg>
);

export const IconArrow = ({ bgColorOppositeShade }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g id="Gruppe_106" data-name="Gruppe 106" transform="translate(-280 -974)">
      <circle
        fill={bgColorOppositeShade}
        id="Ellipse_60"
        data-name="Ellipse 60"
        cx="16"
        cy="16"
        r="16"
        transform="translate(280 974)"
      />
      <g id="Gruppe_105" data-name="Gruppe 105" transform="translate(291.667 997.4) rotate(-90)">
        <g id="Gruppe_103" data-name="Gruppe 103">
          <path
            id="Pfad_634"
            data-name="arrow"
            d="M152.637,185l-6.2-6.2a1.239,1.239,0,0,0-1.747,0l-6.2,6.2a1.239,1.239,0,0,0,1.747,1.747l5.317-5.317,5.329,5.317A1.236,1.236,0,1,0,152.637,185Z"
            transform="translate(-138.197 -178.446)"
            // fill="#0fb4bc"
          />
        </g>
      </g>
    </g>
  </svg>
);
